import React, { useState } from "react";
import Button from "../../../components/buttons/Button";
import Dialog from "../../../components/dialog/Dialog";
import Content from "../../../components/Content";
import { useNavigate } from "react-router-dom";
import { ActivityTable } from "../../../components/service/ActivityTable";
import { CreateActivityModal } from "../../../modals/service/CreateActivityModal";
import SearchInput from "../../../components/Inputs/SearchInput";
import { Typography, Box, Card, CardContent } from "@mui/material";

export const ActivityView = () => {
  const navigate = useNavigate();

  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

  const clickRow = (id) => {
    // id is already transformed from the backend
    navigate(`./overview/${id}`);
  };

  return (
    <>
      <Content title={"Aktiviteter"}>
        <Box sx={{ p: 3 }}>
          <Card sx={{ mb: 3 }}>
            <CardContent>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  mb: 2,
                }}
              >
                <Typography variant="h6" gutterBottom>
                  Aktiviteter
                </Typography>
                <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                  <SearchInput />
                  <Button onClick={() => setIsCreateModalOpen(true)}>
                    Skapa Ny Aktivitet
                  </Button>
                </Box>
              </Box>
              <Typography variant="body1" color="text.secondary">
                Hantera aktiviteter för din organisation. Skapa och organisera olika aktiviteter som kan kopplas till tjänster och spåras i systemet.
              </Typography>
            </CardContent>
          </Card>

          <Card>
            <CardContent>
              <ActivityTable handleSelect={(item) => clickRow(item.id)} />
            </CardContent>
          </Card>
        </Box>
          <Dialog
            open={isCreateModalOpen}
            onClose={() => setIsCreateModalOpen(false)}
            title="Skapa Aktivitet"
          >
            <CreateActivityModal
              closeCreateModal={() => setIsCreateModalOpen(false)}
            />
          </Dialog>
      </Content>
    </>
  );
};
